<ngx-loading [show]="loading" [config]="{ backdropBackgroundColour: 'rgba(0,0,0,0.6)' }" #customLoadingTemplate></ngx-loading>

<div class="containerSearchTxtOrder" style="margin-bottom: 7px; margin-top: -9px;">
  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading" (click)="refrehPage()">
    <img title="Atualizar" style="cursor: pointer; cursor: pointer; height: 24px; width: 24px; cursor: inherit;" src="/update.svg" />
  </button>

  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading">
    <img title="Buscar" style="height: 24px; width: 24px; cursor: inherit; " src="/search.svg" />
  </button>

  <!-- Selecione se deve apresentar pedidos aguardando aprovação backoffice ou antifraude -->
  <mat-form-field class="select-form order-blocked-filter">
    <mat-label>
      Status de restrição
    </mat-label>
    <mat-select matInput name="orderBlockedFilter" [(value)]="orderBlockedSelected" class="filter-field">
      <mat-option (click)="changeOrderBlocked('pending-verification')" value="pending-verification">aguardando aprovação backoffice</mat-option>
      <mat-option (click)="changeOrderBlocked('pending-verification-antifraude')" value="pending-verification-antifraude">aguardando aprovação antifraude</mat-option>
      <mat-option (click)="changeOrderBlocked('released')" value="released">liberados</mat-option>
      <mat-option (click)="changeOrderBlocked('not-released')" value="not-released">bloqueados</mat-option>
    </mat-select>
  </mat-form-field>

  <input type="text" (ngxInputSearch)="doSearch($event)"
         (emptyInput)="doSearchClear()"
         stringLength="0" class="searchTxt" placeholder="OV/PEDIDO" />
</div>
<table class='table table-striped table-without-width table-with-minwidth' aria-labelledby="tableLabel" align="center">
  <thead>
    <tr>
      <th style="text-align:center;">Tempo<br />percorrido</th>
      <th style="text-align:center;">Data/Hora</th>
      <th>Nome</th>
      <th style="text-align:center;">CPF/CNPJ</th>
      <th>Número do pedido</th>
      <th style="text-align:center;">Valor</th>
      <th style="text-align:center;">Forma de<br />pagamento</th>
      <th style="text-align:center;">Tipo de<br />bloqueio</th>
      <th style="text-align:center;">Quantidade<br />de Pedido no dia</th>
      <th style="text-align:center;">Status do<br />Pedidos</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of orderTrackings | paginate: { id: 'orderBlockedPage', itemsPerPage: pageSize, currentPage: page, totalItems: total }; let iS = index">
      <td style="text-align:center;" title="{{ item.orderLifeTimeFormated}}">{{ item.orderLifeTimeFormated }}</td>
      <td style="text-align:center;" title="{{ item.creationDateFormated }}">{{ item.creationDateFormated }}</td>
      <td style="white-space: inherit !important;" title="{{ item.customer.nome }}">{{ item.customer.nome }}</td>
      <td style="text-align:center;" title="{{ item.customer.cpfCnpj }}">{{ item.customer.cpfCnpj }}</td>

      <td *ngIf="item.orderNumber.indexOf('APPF_') >= 0" style="text-align:center;" title="{{ item.orderNumber }}">{{ item.orderNumber }}</td>
      <td *ngIf="item.orderNumber.indexOf('APPF_') == -1" style="text-align:center;" title="{{ item.agroup }}">{{ item.agroup }}</td>

      <td style="text-align:center;" title="{{ item.totalValueFormated }}">{{ item.totalValueFormated }}</td>
      <td style="text-align:center;" title="{{ item.paymentMethod.name }}">{{ item.paymentMethod.name }}</td>
      <td style="text-align:center;" title="{{ item.dailyPurchaseLimitTypeName }}">{{ item.dailyPurchaseLimitTypeName }}</td>
      <td style="text-align:center;" title="{{ item.accountOrdersCountDay }}">{{ item.accountOrdersCountDay }}</td>

      <td style="text-align:center;">
        <div *ngIf="item.dailyPurchaseLimit=='pending-verification' || item.dailyPurchaseLimit=='pending-verification-antifraude'" class="icon-alertOrange"></div>
        <div *ngIf="item.dailyPurchaseLimit=='released'" class="icon-ok"></div>
        <div *ngIf="item.dailyPurchaseLimit=='not-released'" class="icon-not-ok"></div>
      </td>

      <td class="txt-action">
        <button class="btn btn-img-nocircle details btn-detail" [disabled]="loading" (click)="openModalFraudAnalysis('modalFraudAnalysis', $event, item)"></button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="11"><p *ngIf="!orderTrackings && !loading"><em>Sem dados</em></p>
        <pagination-controls id="orderBlockedPage"
                             (pageChange)="pageChanged($event)"
                             (pageBoundsCorrection)="pageChanged($event)"
                             maxSize="9"
                             directionLinks="true"
                             autoHide="true"
                             responsive="true"
                             previousLabel="anterior"
                             nextLabel="próximo"
                             screenReaderPaginationLabel="Paginação"
                             screenReaderPageLabel="pagina"
                             screenReaderCurrentLabel="você esta na página">
        </pagination-controls>
      </td>
    </tr>
  </tfoot>
</table>

<div class="modal" id="modalFraudAnalysis" role="dialog" *ngIf="orderTrackingSelected">
  <div class="modal-dialog modal-dialog-blocked">
    <div class="modal-content modal-content-blocked">
      <div class="modal-header">
        <h3>Analise de pedido</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalFraudAnalysis')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <mat-card class="card-order-blocked">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Dados do pedido</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-form-field>
              <mat-label>Tempo percorrido</mat-label>
              <input matInput value="{{orderTrackingSelected.orderLifeTimeFormated}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Data/Hora</mat-label>
              <input matInput value="{{orderTrackingSelected.creationDateFormated}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Nome</mat-label>
              <input matInput value="{{orderTrackingSelected.customer.nome}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>CPF/CNPJ</mat-label>
              <input matInput value="{{orderTrackingSelected.customer.cpfCnpj}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Valor</mat-label>
              <input matInput value="{{orderTrackingSelected.totalValueFormated}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Forma de pagamento</mat-label>
              <input matInput value="{{orderTrackingSelected.paymentMethod.name}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Tipo de bloqueio</mat-label>
              <input matInput value="{{orderTrackingSelected.dailyPurchaseLimitTypeName}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Restrição alterada por</mat-label>
              <input matInput value="{{ orderTrackingSelected.dailyPurchaseLimitChangedBy }}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Restrição alterada em</mat-label>
              <input matInput value="{{ orderTrackingSelected.dailyPurchaseLimitChangedDate | date:'dd/MM/yyyy HH:mm' }}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Quantidade de Pedidos</mat-label>
              <input matInput value="{{ orderTrackingSelected.accountOrders.length }}" disabled>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <br />
        <mat-card class="card-order-blocked">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Últimos pedidos</mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <table class='table table-striped' aria-labelledby="tableLabel" align="center">
              <thead>
                <tr>
                  <th style="text-align:center;">Pedido</th>
                  <th style="text-align:center;">Data/Hora</th>
                  <th style="text-align:center;">Status do pedido</th>
                  <th style="text-align:center;">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of orderTrackingSelected.accountOrders;">
                  <td *ngIf="item.orderNumber.indexOf('APPF_') >= 0" style="text-align:center;" title="{{ item.orderNumber }}">{{ item.orderNumber }}</td>
                  <td *ngIf="item.orderNumber.indexOf('APPF_') == -1" style="text-align:center;" title="{{ item.agroup }}">{{ item.agroup }}</td>
                  <td style="text-align:center;" title="{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}">{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td style="text-align:center;" title="{{ item.statusDescription }}">{{ item.statusDescription }}</td>
                  <td style="text-align:center;" title="{{ item.totalValue | currency : 'R$' }}">{{ item.totalValue | currency : 'R$' }}</td>
                </tr>
              </tbody>
            </table>


          </mat-card-content>
        </mat-card>
      </div>
      <div *ngIf="!loading && currentUser.userPermission.orderBlocked.write && orderTrackingSelected.dailyPurchaseLimit == 'pending-verification'" class="modal-footer">
        <button class="btn btn-outline" [disabled]="loading" (click)="releaseOrder('modalAlert', $event, true)">Liberar pedido</button>
        <button class="btn btn-outline btnCancel" [disabled]="loading" (click)="releaseOrder('modalAlert', $event, false)">Cancelar pedido</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="modalAlert" role="dialog">
  <div class="modal-dialog modal-dialog-confirm">
    <div class="modal-content">
      <div class="modal-header" [ngClass]="changeTo ? 'modal-header-warn' : 'modal-header-alert'">
        <h3>Confirmação de analise</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalAlert')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <br />
        <br />
        <h4>{{ textConfirm }}</h4>
        <br />
        <br />
      </div>
      <div *ngIf="!loading" class="modal-footer">
        <button class="btn btn-outline" [disabled]="loading" (click)="setOrderResultFraudAnalysis()">Confirmar</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="modalError" role="dialog">
  <div class="modal-dialog modal-dialog-alert">
    <div class="modal-content">
      <div class="modal-header modal-header-alert">
        <h3>Confirmação de analise</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalError')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <br />
        <br />
        <h4>{{ textError }}</h4>
        <br />
        <br />
      </div>
    </div>
  </div>
</div>
